<template>
  <font-awesome-icon
    icon="copy"
    size="lg"
    class="icon"
    @click.stop="copyQuiz()"/>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    quizset: {
      required: true,
      type: Object
    }
  },

  methods: {
    copyQuiz: function () {
      if (window.confirm('クイズセットをコピーしますか？')) {
        this.$store.dispatch('quizset/copy', this.quizset)
      }
    }
  }
}
</script>
